import React from "react";

const LOGO_SRC = "/brand/gges-logo.png";

// Image-based logo. Uses the official GGES Ventures mark.
export function Logo({ size = "md", className = "" }) {
  const sizes = {
    sm: "h-9",
    md: "h-14",
    lg: "h-24",
    xl: "h-32",
  };
  const h = sizes[size] || sizes.md;
  return (
    <div
      className={`inline-flex items-center justify-center ${className}`}
      data-testid="gges-logo"
      role="img"
      aria-label="GGES Ventures"
    >
      <img
        src={LOGO_SRC}
        alt="GGES Ventures"
        className={`${h} w-auto object-contain select-none`}
        draggable="false"
      />
    </div>
  );
}
